"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.PresenceListener = void 0;
/**
 * A class that listens for presence messages and broadcasts the client's own
 * presence messages.
 */
var PresenceListener = /** @class */ (function () {
    function PresenceListener(options) {
        var _a, _b, _c, _d;
        this.presence = {};
        this.interval = null;
        // Time of the last update caused by a state change.
        this.lastUpdate = 0;
        this.updateHandle = null;
        this.nextUpdate = Date.now();
        this.state = options.initialState;
        this.db = options.db;
        this.key = (_a = options.key) !== null && _a !== void 0 ? _a : '__presence';
        this.clientId = options.clientId;
        this.callback = (_b = options.callback) !== null && _b !== void 0 ? _b : (function () { });
        this.minPresenceInterval = (_c = options.minPresenceInterval) !== null && _c !== void 0 ? _c : 20; // 20 ms
        this.maxPresenceInterval = (_d = options.maxPresenceInterval) !== null && _d !== void 0 ? _d : 1000; // 1 second
        this.onMessage = this.onMessage.bind(this);
    }
    PresenceListener.prototype.subscribe = function () {
        var _this = this;
        this.updateHandle = setTimeout(function () {
            _this.update();
        }, 0);
        this.db.subscribe(this.key, this.onMessage);
        this.interval = setInterval(function () {
            for (var client in _this.presence) {
                if (Date.now() - _this.presence[client].lastSeen > _this.maxPresenceInterval * 2) {
                    delete _this.presence[client];
                }
            }
        }, this.maxPresenceInterval);
    };
    PresenceListener.prototype.destroy = function () {
        if (this.interval !== null) {
            clearInterval(this.interval);
        }
        if (this.updateHandle !== null) {
            clearTimeout(this.updateHandle);
        }
        this.db.unsubscribe(this.key, this.onMessage);
    };
    PresenceListener.prototype.onMessage = function (event) {
        var _a;
        var message = event.value;
        if (message.client === this.clientId) {
            // Ignore our own messages.
            return;
        }
        this.presence = __assign(__assign({}, this.presence), (_a = {}, _a[message.client] = {
            value: message.value,
            lastSeen: Date.now()
        }, _a));
        this.callback(this.presence);
    };
    PresenceListener.prototype.update = function () {
        var _this = this;
        this.db.send({
            type: 'push',
            action: { type: 'relay' },
            value: { value: this.state, client: this.clientId },
            key: this.key
        });
        this.nextUpdate = Date.now() + this.maxPresenceInterval;
        this.lastUpdate = Date.now();
        this.updateHandle = setTimeout(function () {
            _this.update();
        }, this.maxPresenceInterval);
    };
    /**
     * Update the client's own presence state.
     *
     * This is debounced locally, so if it is called multiple times in a short
     * period of time, only the last call will be sent.
     */
    PresenceListener.prototype.updateState = function (value) {
        var _this = this;
        if (JSON.stringify(value) === JSON.stringify(this.state)) {
            return;
        }
        this.state = value;
        var nextUpdate = this.lastUpdate + this.minPresenceInterval;
        if (nextUpdate < this.nextUpdate) {
            this.nextUpdate = nextUpdate;
            if (this.updateHandle !== null) {
                clearTimeout(this.updateHandle);
            }
            this.updateHandle = setTimeout(function () {
                _this.update();
            }, this.nextUpdate - Date.now());
        }
    };
    return PresenceListener;
}());
exports.PresenceListener = PresenceListener;
